// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".schedule[data-v-3bfe07d2]{font-size:300;font-weight:700}", ""]);
// Exports
module.exports = exports;
